/** The shaded raster as a data URL for a MapLibre image source. Needs a real canvas, so it stays out of the pure module. */
import type { Shaded } from './shade';

export function shadedImageUrl(shaded: Shaded): string | null {
  const canvas = document.createElement('canvas');
  canvas.width = shaded.width;
  canvas.height = shaded.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  // A fresh copy sits on a plain ArrayBuffer, which is what ImageData's typing asks for.
  ctx.putImageData(new ImageData(new Uint8ClampedArray(shaded.pixels), shaded.width, shaded.height), 0, 0);
  return canvas.toDataURL('image/png');
}
